import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type {
  CreateUserGroupRequest,
  UserGroupRecord,
} from "../UserGroupRecord";

import * as UseUserGroups from "./useUserGroups";

export function useCreateUserGroup() {
  const { userGroupService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<UserGroupRecord, Error, CreateUserGroupRequest>({
    mutationFn: (request) => userGroupService.create(request),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UseUserGroups.getQueryKey(),
      });
    },
  });
}
